import React, { useState, useEffect } from 'react';
import { Container, Alert, Card, Button, Spinner } from 'react-bootstrap';

const getAccessToken = (): string => {
  const accessLoginRaw = localStorage.getItem('loginInfo_ninegrid_access');
  const admLoginRaw = localStorage.getItem('loginInfo_ninegrid_adm');
  const legacyToken = localStorage.getItem('auth_token');

  if (accessLoginRaw) {
    try {
      const parsed = JSON.parse(accessLoginRaw);
      if (parsed?.accessToken) {
        return parsed.accessToken;
      }
    } catch {
      // Ignora erro de parse e segue fallback
    }
  }

  if (admLoginRaw) {
    try {
      const parsed = JSON.parse(admLoginRaw);
      if (parsed?.accessToken) {
        return parsed.accessToken;
      }
    } catch {
      // Ignora erro de parse e segue fallback
    }
  }

  return legacyToken || '';
};

const FeedbackDiagnostic: React.FC = () => {
  const [checks, setChecks] = useState<{
    token: { ok: boolean; message: string };
    apiUrl: { ok: boolean; message: string };
    apiCall: { ok: boolean; message: string; data?: any };
    loading: boolean;
  }>({
    token: { ok: false, message: 'Verificando...' },
    apiUrl: { ok: false, message: 'Verificando...' },
    apiCall: { ok: false, message: 'Aguardando...' },
    loading: true,
  });

  useEffect(() => {
    const runDiagnostics = async () => {
      // Check token
      const token = getAccessToken();
      const tokenOk = Boolean(token && token.length > 10);
      
      // Check API URL
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:7004/api';
      
      // Try API call
      try {
        const response = await fetch(
          `${apiUrl}/feedback-review-hotel/analytics/dashboard`,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        const data = await response.json();
        
        setChecks({
          token: {
            ok: tokenOk,
            message: tokenOk 
              ? `✓ Token encontrado: ${token.substring(0, 20)}...` 
              : '✗ Token não encontrado no storage padrao',
          },
          apiUrl: {
            ok: true,
            message: `API URL: ${apiUrl}`,
          },
          apiCall: {
            ok: response.ok,
            message: `Status: ${response.status} ${response.statusText}`,
            data: data,
          },
          loading: false,
        });
      } catch (error: any) {
        setChecks({
          token: {
            ok: tokenOk,
            message: tokenOk 
              ? `✓ Token encontrado: ${token?.substring(0, 20)}...` 
              : '✗ Token não encontrado no storage padrao',
          },
          apiUrl: {
            ok: true,
            message: `API URL: ${apiUrl}`,
          },
          apiCall: {
            ok: false,
            message: `✗ Erro na requisição: ${error.message}`,
            data: { error: error.message },
          },
          loading: false,
        });
      }
    };

    runDiagnostics();
  }, []);

  return (
    <Container className="py-5">
      <h1 className="mb-4">🔧 Diagnóstico - Dashboard de Feedback</h1>
      
      {checks.loading && (
        <div className="text-center py-5">
          <Spinner animation="border" className="mb-3" />
          <p>Verificando configurações...</p>
        </div>
      )}

      {!checks.loading && (
        <>
          <Card className="mb-3" border={checks.token.ok ? 'success' : 'danger'}>
            <Card.Header className={checks.token.ok ? 'bg-success text-white' : 'bg-danger text-white'}>
              Token de Autenticação
            </Card.Header>
            <Card.Body>
              <p>{checks.token.message}</p>
              <code>{getAccessToken()?.substring(0, 50)}...</code>
            </Card.Body>
          </Card>

          <Card className="mb-3" border={checks.apiUrl.ok ? 'success' : 'danger'}>
            <Card.Header className={checks.apiUrl.ok ? 'bg-success text-white' : 'bg-danger text-white'}>
              URL da API
            </Card.Header>
            <Card.Body>
              <p>{checks.apiUrl.message}</p>
            </Card.Body>
          </Card>

          <Card className="mb-3" border={checks.apiCall.ok ? 'success' : 'danger'}>
            <Card.Header className={checks.apiCall.ok ? 'bg-success text-white' : 'bg-danger text-white'}>
              Chamada à API
            </Card.Header>
            <Card.Body>
              <p>{checks.apiCall.message}</p>
              <pre className="bg-light p-3 rounded">
                {JSON.stringify(checks.apiCall.data, null, 2)}
              </pre>
            </Card.Body>
          </Card>

          {!checks.apiCall.ok && (
            <Alert variant="warning">
              <Alert.Heading>⚠️ Problemas Detectados</Alert.Heading>
              <ul>
                {!checks.token.ok && <li>Token de autenticação não encontrado</li>}
                {checks.apiCall.ok === false && <li>API não está respondendo corretamente</li>}
              </ul>
              <hr />
              <p className="mb-0">
                <strong>Soluções:</strong>
                <ul>
                  <li>Verifique se está logado no sistema</li>
                  <li>Verifique se o backend está rodando: http://localhost:7004</li>
                  <li>Verifique os logs do backend em caso de erro 500</li>
                  <li>Tente fazer logout e login novamente</li>
                </ul>
              </p>
            </Alert>
          )}

          {checks.apiCall.ok && (
            <Alert variant="success">
              ✓ Tudo parece estar funcionando! O problema pode estar no frontend.
            </Alert>
          )}

          <Button 
            variant="primary" 
            onClick={() => window.location.reload()}
            className="me-2"
          >
            Recarregar Página
          </Button>
          <Button 
            variant="secondary" 
            onClick={() => window.history.back()}
          >
            Voltar
          </Button>
        </>
      )}
    </Container>
  );
};

export default FeedbackDiagnostic;
